/**
 * Contains api functions.
 * @namespace api
 * @category Services
 */
// eslint-disable-next-line
const shared = {};
//used for the namespace in the documentation

/**
 * The url to which endpoints are attached for the api calls.
 * @memberof api
 */
const apiURL = window.__CONFIG__.API_URL;

/**
 * Generic function to fetch data from the given endpoint.
 * @memberof api
 * @function fetchData
 * @param {string} endpoint - The endpoint to fetch data from.
 * @returns {Promise}
 */
const fetchData = async (endpoint) => {
  try {
    const res = await fetch(apiURL + endpoint);
    if (!res.ok) {
      throw new Error(`Error fetching data from ${endpoint}: ${res.statusText}`);
    }
    return res.json();
  } catch (error) {
    if (error.message === "Failed to fetch") {
      window.location.reload();
    }
  }
};

/**
 * Fetches chargers.
 * @memberof api
 * @function fetchChargers
 * @returns {Promise}
 */
export const fetchChargers = () => fetchData("chargers");

/**
 * Fetches cycleways.
 * @memberof api
 * @function fetchCycleways
 * @returns {Promise}
 */
export const fetchCycleways = () => fetchData("cycleways");

/**
 * Fetches subway lines.
 * @memberof api
 * @function fetchSubwayLines
 * @returns {Promise}
 */
export const fetchSubwayLines = () => fetchData("subway-lines");

/**
 * Fetches subway stations.
 * @memberof api
 * @function fetchSubwayStations
 * @returns {Promise}
 */
export const fetchSubwayStations = () => fetchData("subway-stations");

/**
 * Fetches lines data.
 * @memberof api
 * @function fetchLinesData
 * @returns {Promise}
 */
export const fetchLinesData = () => fetchData("lines-data");

/**
 * Fetches repairworks data.
 * @memberof api
 * @function fetchReconstructionsData
 * @returns {Promise}
 */
export const fetchReconstructionsData = () => fetchData("reconstructions");
